<template>
  <h1 class="text-primary-main text-center font-semibold text-[22px] leading-8">
    <slot />
  </h1>
</template>

<script>
export default {
  name: "AuthHeading",
};
</script>

<style lang="scss" scoped></style>
